module.exports = __webpack_public_path__ + "static/media/Sign in 2.9562aa9d.svg";